"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfTopicSubscriptionAckDto = instanceOfTopicSubscriptionAckDto;
exports.TopicSubscriptionAckDtoFromJSON = TopicSubscriptionAckDtoFromJSON;
exports.TopicSubscriptionAckDtoFromJSONTyped = TopicSubscriptionAckDtoFromJSONTyped;
exports.TopicSubscriptionAckDtoToJSON = TopicSubscriptionAckDtoToJSON;
exports.TopicSubscriptionAckDtoToJSONTyped = TopicSubscriptionAckDtoToJSONTyped;
/**
 * Check if a given object implements the TopicSubscriptionAckDto interface.
 */
function instanceOfTopicSubscriptionAckDto(value) {
    if (!('subscribed' in value) || value['subscribed'] === undefined)
        return false;
    return true;
}
function TopicSubscriptionAckDtoFromJSON(json) {
    return TopicSubscriptionAckDtoFromJSONTyped(json, false);
}
function TopicSubscriptionAckDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'subscribed': json['subscribed'],
    };
}
function TopicSubscriptionAckDtoToJSON(json) {
    return TopicSubscriptionAckDtoToJSONTyped(json, false);
}
function TopicSubscriptionAckDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'subscribed': value['subscribed'],
    };
}
